import React from 'react';
import { ReactComponent as Tick } from '../../../../assets/svg/ProjectOverview/TickIcon.svg';
import { ReactComponent as Seperator } from '../../../../assets/svg/ProjectOverview/ChecklistSeperator.svg';

const PendingIconHolder = () => {
	return (
		<div className="PendingIconContainer">
			<div className="pendingbackIconHolder"></div>
		</div>
	);
};

const CompletedIconHolder = () => {
	return (
		<div className="CompletedIconContainer">
			<div className="backIconHolder"></div>
			<div className="tickIcon">
				<Tick />
			</div>
		</div>
	);
};

const UnknownStateHolder = () => {
	return (
		<div className="UnknownIconContainer">
			<div className="unknownbackIconHolder"></div>
		</div>
	);
};

const TimeLineComponent = ({ data }) => {
	return (
		<div className="TimelineParentContainer">
			{data?.map((e, index) => (
				<div className="timlineChild">
					<div className="IconseperatorCOntainer">
						<div className="Checklisticon">
							{e.state == 'Completed' ? (
								<CompletedIconHolder />
							) : e.state == 'Pending' ? (
								<PendingIconHolder />
							) : (
								<UnknownStateHolder />
							)}
						</div>
						<div className="TimelineSeperator">
							{data[index + 1] ? <Seperator /> : ''}
						</div>
					</div>

					<div className="contentHolder" style={{marginTop:e.state==='unknown'?'0px':'2px'}}>
						<div className="ContentTitle">{e.title}</div>
						<div className="ContentTimings">{e.timings}</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default TimeLineComponent;


